import React from "react";
import CountUp from "react-countup";
import { NavLink } from "react-router-dom";
import ReactPlayer from "react-player";

var img1 = "/assets/media/video/pic.png";

class OurValue extends React.Component {
  componentDidMount() {
    function loadScript(src) {
      return new Promise(function (resolve, reject) {
        var script = document.createElement("script");
        script.src = src;
        script.addEventListener("load", function () {
          resolve();
        });
        script.addEventListener("error", function (e) {
          reject(e);
        });
        document.body.appendChild(script);
        document.body.removeChild(script);
      });
    }

    loadScript("./assets/js/masonary.js");
  }

  render() {
    return (
      <>
        <div className="section-full mobile-page-padding p-t80 p-b30 bg-white">
          <div className="container">
            <div className="section-content">
              <div className="row">
                <div className="col-md-4 col-sm-12">
                  {/* TITLE START */}
                  <div className="section-head">
                    <div className="mt-separator-outer separator-left">
                      <div className="mt-separator">
                        <h2 className="text-uppercase sep-line-one ">
                          <span className="font-weight-300 text-primary">
                            Our
                          </span>{" "}
                          Value
                        </h2>
                      </div>
                      <p>
                        Our platform also provides suppliers with the
                        opportunity to grow their market and increase capacity
                        utilization. We are a technology-first brand that is
                        digitizing the entire ecosystem, making it more
                        efficient, transparent, and accessible for businesses.
                      </p>
                    </div>
                  </div>
                  {/* TITLE END */}
                  <div className="author-info p-t20"></div>
                  <div
                    className="video-section-full bg-no-repeat bg-cover overlay-wraper"
                    style={{ backgroundImage: `url(${img1})` }}
                  >
                    <div className="overlay-main bg-black opacity-07" />  
                    <div className="video-section-inner">
                      <div className="video-section-content">
                        <div className="video-section-left">
                          <button
                            type="button"
                            className="play-now"
                            data-toggle="modal"
                            data-target="#myModal2"
                          >
                            <i className="icon fa fa-play" />
                            <span className="ripple" />
                          </button>
                        </div>
                        <div className="video-section-right">
                          <NavLink
                            to={"#"}
                            className="font-weight-600 text-uppercase"
                            data-toggle="modal"
                            data-target="#myModal"
                          >
                            Video Presentation
                          </NavLink>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-3 col-sm-6">
                  <div className="mt-count m-b30 text-white mt-icon-box-wraper center  bg-dark p-a20">
                    <div className="counter font-30 font-weight-800 m-b15 text-primary">
                      <CountUp end={17} duration={5} /> +
                    </div>
                    <h4 className="m-tb0">Trusted Brands </h4>
                  </div>
                  <div className="mt-count m-b30 text-white mt-icon-box-wraper center  bg-dark p-a20">
                    <div className="counter font-30 font-weight-800 m-b15  text-primary">
                      <CountUp end={5} duration={5} />
                    </div>
                    <h4 className="m-tb0">Product Categories</h4>
                  </div>
                  <div className="mt-count m-b30 text-white mt-icon-box-wraper center  bg-dark p-a20">
                    <div className="counter font-30 font-weight-800 m-b15 text-primary">
                      <CountUp end={100} duration={5} />%
                    </div>
                    <h4 className="m-tb0">Quality Assured</h4>
                  </div>
                </div>
                <div className="col-md-5 col-sm-6">
                  <div className="p-b0">
                    <div className="mt-box">
                      <h3 className="m-t0">
                        <span className="font-weight-100"> We have</span>
                        <span className="text-primary"> 30 years</span>{" "}
                        experience in Building Materials
                      </h3>
                    </div>
                    <span className="progressText text-black">
                      <b> Cement</b>
                    </span>
                    <div className="progress mt-probar-1  m-b30 m-t10">
                      <div
                        className="progress-bar bg-primary "
                        role="progressbar"
                        aria-valuenow={85}
                        aria-valuemin={7}
                        aria-valuemax={100}
                      >
                        <span
                          className="popOver"
                          data-toggle="tooltips"
                          data-placement="top"
                          title="85%"
                        />
                      </div>
                    </div>
                    <span className="progressText text-black">
                      <b>Plumbing</b>
                    </span>
                    <div className="progress mt-probar-1 m-b30 m-t10">
                      <div
                        className="progress-bar bg-primary"
                        role="progressbar"
                        aria-valuenow={78}
                        aria-valuemin={10}
                        aria-valuemax={100}
                      >
                        <span
                          className="popOver"
                          data-toggle="tooltips"
                          data-placement="top"
                          title="60%"
                        />
                      </div>
                    </div>
                    <span className="progressText text-black">
                      <b>Paint</b>
                    </span>
                    <div className="progress mt-probar-1 m-b30 m-t10">
                      <div
                        className="progress-bar bg-primary"
                        role="progressbar"
                        aria-valuenow={65}
                        aria-valuemin={0}
                        aria-valuemax={100}
                      >
                        <span
                          className="popOver"
                          data-toggle="tooltips"
                          data-placement="top"
                          title="65%"
                        />
                      </div>
                    </div>
                    <span className="progressText text-black">
                      <b>Steel</b>
                    </span>
                    <div className="progress mt-probar-1 m-b30 m-t10">
                      <div
                        className="progress-bar bg-primary"
                        role="progressbar"
                        aria-valuenow={40}
                        aria-valuemin={0}
                        aria-valuemax={100}
                      >
                        <span
                          className="popOver"
                          data-toggle="tooltips"
                          data-placement="top"
                          title="75%"
                        />
                      </div>
                    </div>
                    <span className="progressText text-black">
                      <b>Electrical</b>
                    </span>
                    <div className="progress mt-probar-1 m-b30 m-t10">
                      <div
                        className="progress-bar bg-primary"
                        role="progressbar"
                        aria-valuenow={55}
                        aria-valuemin={0}
                        aria-valuemax={100}
                      >
                        <span
                          className="popOver"
                          data-toggle="tooltips"
                          data-placement="top"
                          title="30%"
                        />
                      </div>
                    </div>
                    <span className="progressText text-black">
                      <b>Bricks</b>
                    </span>
                    <div className="progress mt-probar-1 m-b30 m-t10">
                      <div
                        className="progress-bar bg-primary"
                        role="progressbar"
                        aria-valuenow={55}
                        aria-valuemin={0}
                        aria-valuemax={100}
                      >
                        <span
                          className="popOver"
                          data-toggle="tooltips"
                          data-placement="top"
                          title="40%"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="modal fade" id="myModal2" role="dialog">
          <div className="modal-dialog">
            <div className="modal-content">
              <ReactPlayer url="/assets/media/video/video2.mp4" controls width="100%" height="100%" />
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default OurValue;
